import { Box, Center, Image, Progress, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { colors } from '~/styles/colors';
import logo from '~/assets/images/elgin-branco.png';
import { login } from '~/store/ducks/Auth/actions';
import { AuthService } from '~/store/ducks/Auth/services';
import { ApplicationState } from '~/store/store';

const Login: React.FC = () => {
  const queryParams: any = new URLSearchParams(useLocation().search);
  const code = queryParams.get('code');
  const token = queryParams.get('token');
  const dispatch = useDispatch();
  const history = useHistory();
  const { accessToken } = useSelector((state: ApplicationState) => state.auth);

  const fetchToken = async () => {
    // O token recebido na query string é transformado em token interno pelo
    // RouteWrapper. A saga espera um objeto de resposta OAuth2, não uma string.
    if (code) {
      dispatch(login(code, null));
    }
  };

  useEffect(() => {
    if (!code && !token) {
      window.location.replace(AuthService.getAuthPath(true));
    } else {
      fetchToken();
    }
  }, []);

  useEffect(() => {
    if (accessToken) {
      history.push(`/projects`);
    }
    return () => null;
  }, [accessToken]);

  return (
    <Box w="200px">
      <Center>
        <Image src={logo} alt="Logo Elgin" />
      </Center>
      <Box align="center" width="100%" mt={5}>
        <Text color={colors.gray50} mb={2} fontSize={18}>
          Processando Login...
        </Text>
        <Progress size="sm" colorScheme="twitter" isIndeterminate borderRadius={2} />
      </Box>
    </Box>
  );
};

export default Login;
